import { Component, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
    selector: "alert-message",
    templateUrl: "./alert-message.component.html",
    styleUrls: ["./alert-message.component.scss"],
    animations: [
        trigger("leaveAnimation", [
            transition(":leave", [
                style({ opacity: 1 }),
                animate("500ms", style({ opacity: 0 })),
            ]),
        ]),
    ],
})
export class AlertMessageComponent {
    @Input() public text;
    @Input() public show: boolean;
    @Input() public alertClass: string = "";
}
